// @flow

import Gallery from './gallery';
import ACFGallery from './gallery.acf';
import type { Image } from './types';

export type {
  Image,
};

export {
  ACFGallery,
};

export default Gallery;
